export default __webpack_public_path__ + "img/1-f7b6bde6.png";